import { useEffect, useRef, useState } from 'react';
import NotificationPanel from './NotificationPanel';

function BellIcon() {
  return (
    <svg className="h-[30px] w-[30px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.454 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
      />
    </svg>
  );
}

function NotificationBell() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className={`rounded-full p-1 transition-colors ${
          open
            ? 'bg-[#EEF4FF] text-[#9369CC]'
            : 'text-[#1B1B1B] hover:bg-[#EEF4FF] hover:text-[#9369CC]'
        }`}
        aria-label="Notifications"
        aria-expanded={open}
      >
        <BellIcon />
      </button>
      <NotificationPanel open={open} onClose={() => setOpen(false)} />
    </div>
  );
}

export default NotificationBell;
